import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navigation from './components/Navigation';
import HomeSection from './components/HomeSection';
import AboutSection from './components/AboutSection';
import MenuSection from './components/MenuSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CartModal from './components/CartModal';
import Admin from './components/Admin';
import './App.css'; //this is th avoid the warning in terminal move import to app.css

// Main site component
const MainSite = ({ isCartOpen, openCart, closeCart, isMobileMenuOpen, toggleMobileMenu, closeMobileMenu }) => {
  return (
    <div className="font-inter bg-gradient-to-br from-[#F8E8D2]/20 to-white min-h-screen overflow-x-hidden">
      <Navigation 
        onCartClick={openCart}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuToggle={toggleMobileMenu}
        onMobileMenuClose={closeMobileMenu}
      />
      
      <HomeSection />
      <AboutSection />
      <MenuSection />
      <ContactSection />
      <Footer />
      
      <CartModal 
        isOpen={isCartOpen}
        onClose={closeCart}
      />
    </div>
  );
};

function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route 
            path="/" 
            element={
              <MainSite 
                isCartOpen={isCartOpen}
                openCart={openCart}
                closeCart={closeCart}
                isMobileMenuOpen={isMobileMenuOpen}
                toggleMobileMenu={toggleMobileMenu}
                closeMobileMenu={closeMobileMenu}
              />
            } 
          />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App; 